import { render, staticRenderFns } from "./GalacticSurvey.vue?vue&type=template&id=229e1186&scoped=true&"
import script from "./GalacticSurvey.vue?vue&type=script&lang=js&"
export * from "./GalacticSurvey.vue?vue&type=script&lang=js&"
import style0 from "./GalacticSurvey.vue?vue&type=style&index=0&id=229e1186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e1186",
  null
  
)

export default component.exports